// extracted by mini-css-extract-plugin
export default {"MainHeader":"Headers_MainHeader__S+CR8"};